export default {
    game_presult_public_page: { common: { template: 'dynamic_game_public' } },
    game_presult_showcase_page: { common: { template: 'dynamic_game_public' } },
};
